<template>
    <div class="block-editor meta-send-capi-event">
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">Contact ID</div>
            <TiptapEditor
                placeholder="Contact ID"
                :show-attributes="true"
                :max-character-count="100"
                v-model="clone.contactId"
            />
        </div>

        <div class="editor-row">
            <div class="editor-row-title">Event Tipi</div>
            <a-select class="classic-new-select" placeholder="Event tipi seçin" v-model="clone.eventType">
                <a-select-option value="LeadSubmitted">Lead Gönderildi</a-select-option>
                <a-select-option value="Purchase">Satın Alma</a-select-option>
                <a-select-option value="InitiateCheckout">Sohbet Başlatıldı</a-select-option>
                <a-select-option value="AppointmentBooked">Randevu Oluşturuldu</a-select-option>
                <a-select-option value="AddToCart">Sepete Eklendi</a-select-option>
                <a-select-option value="ViewContent">İçerik Görüntülendi</a-select-option>
                <a-select-option value="OrderCreated">Sipariş Oluşturuldu</a-select-option>
                <a-select-option value="OrderShipped">Sipariş Kargoya Verildi</a-select-option>
            </a-select>
        </div>

        <div
            class="editor-row customize-editor-minimize"
            v-if="['Purchase', 'OrderCreated', 'OrderShipped'].includes(clone.eventType)"
        >
            <div class="editor-row-title">Para Birimi</div>
            <TiptapEditor
                placeholder="TRY, USD, EUR"
                :show-attributes="true"
                :max-character-count="10"
                v-model="clone.currency"
            />
        </div>

        <div
            class="editor-row customize-editor-minimize"
            v-if="['Purchase', 'OrderCreated', 'OrderShipped'].includes(clone.eventType)"
        >
            <div class="editor-row-title">Tutar</div>
            <TiptapEditor
                :placeholder="`Örn: \\{\\{order_total\\}\\} veya 99.99`"
                :show-attributes="true"
                :max-character-count="50"
                v-model="clone.value"
            />
        </div>

        <div class="editor-row">
            <div class="editor-row-title">Ek Bilgiler (Opsiyonel)</div>
            <div class="custom-data-list">
                <div v-for="(item, index) in clone.customData" :key="index" class="custom-data-item">
                    <input v-model="item.key" placeholder="Anahtar" class="key-input" />
                    <TiptapEditor
                        placeholder="Değer"
                        :show-attributes="true"
                        :max-character-count="200"
                        v-model="item.value"
                        class="value-input"
                    />
                    <button @click="removeCustomData(index)" class="remove-btn">
                        <i class="material-icons">delete</i>
                    </button>
                </div>
                <button @click="addCustomData" class="add-btn">
                    <i class="material-icons">add</i>
                    Ek Alan Ekle
                </button>
            </div>
        </div>

        <div class="info-box">
            <i class="material-icons">info</i>
            <p>
                CAPI eventi göndermek için visitor'ın kanalında CAPI ayarlarının yapılmış olması gerekir. Belirtilen
                Contact ID üzerinden kanal ve gerekli Meta bilgileri (Instagram User ID, Messenger User ID, Meta Lead
                ID vb.) otomatik olarak alınacaktır.
            </p>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import { mapState } from "vuex";

const log = log2("MetaSendCapiEvent");
export default {
    name: "MetaSendCapiEvent",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site._id,
        }),
    },
    methods: {
        addCustomData() {
            if (!Array.isArray(this.clone.customData)) {
                this.clone.customData = [];
            }
            this.clone.customData.push({
                key: "",
                value: "",
            });
        },
        removeCustomData(index) {
            this.clone.customData.splice(index, 1);
        },
    },
    mounted() {
        if (!this.clone.contactId) {
            this.clone.contactId = "{{visitor.id}}";
        }
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.block-editor.meta-send-capi-event {
    padding: 20px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 20px;

    .ant-select {
        width: 100%;
    }

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
            display: flex;
            align-items: center;
            gap: 5px;
            margin-bottom: 8px;
        }

        .custom-data-list {
            display: flex;
            flex-direction: column;
            gap: 10px;

            .custom-data-item {
                display: flex;
                gap: 10px;
                align-items: center;

                .key-input {
                    width: 30%;
                    padding: 8px 12px;
                    border: 1px solid #d9d9d9;
                    border-radius: 4px;
                    font-size: 14px;

                    &:focus {
                        outline: none;
                        border-color: #40a9ff;
                        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
                    }
                }

                .value-input {
                    flex: 1;
                }

                .remove-btn {
                    padding: 4px 8px;
                    border: none;
                    background: #ff4d4f;
                    color: white;
                    border-radius: 4px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    transition: all 0.2s;

                    &:hover {
                        background: #ff7875;
                    }

                    i {
                        font-size: 16px;
                    }
                }
            }

            .add-btn {
                width: fit-content;
                padding: 6px 12px;
                border: 1px dashed #d9d9d9;
                background: transparent;
                border-radius: 4px;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 5px;
                transition: all 0.2s;

                &:hover {
                    border-color: #40a9ff;
                    color: #40a9ff;
                }

                i {
                    font-size: 16px;
                }
            }
        }
    }

    .info-box {
        display: flex;
        gap: 10px;
        padding: 12px;
        background: #e3f2fd;
        border-radius: 6px;
        border-left: 4px solid #2196f3;
        width: 100%;

        i {
            color: #2196f3;
            font-size: 20px;
        }

        p {
            margin: 0;
            font-size: 13px;
            color: #1565c0;
            line-height: 1.5;
        }
    }
}
</style>

